export class TabModel {
    title: string;
    component: any;
    active: boolean = false;
    autoSelection: boolean = false;
    data: any;
}